import { render, staticRenderFns } from "./Locomotion.vue?vue&type=template&id=18265d70"
import script from "./Locomotion.vue?vue&type=script&lang=js"
export * from "./Locomotion.vue?vue&type=script&lang=js"
import style0 from "./Locomotion.vue?vue&type=style&index=0&id=18265d70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports